import React, { Component } from 'react';

import { Fabric } from 'office-ui-fabric-react/lib/Fabric';

import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import Cookies from "universal-cookie";
import HttpService from '../service/HttpService';

export default class Login extends Component {
  toPost = {}
  http = new HttpService();

  constructor( props ) {
    super( props );

    let cookies = new Cookies();
    let session = cookies.get( 'session' );

    if( session ) {
      window.location.href = '/';
    }
  }

  updateItem = ( item ) => {
    this.toPost[item.target.name] = item.target.value;
  }

  login = () => {
    this.http
      .login( this.toPost )
      .then( ( response ) => {
        if( response.success ) {
          let cookies = new Cookies();
    
          cookies.set( 'session', response.token, { path: '/' });
          
          window.location.href = '/';
        }
      })
      .catch( error => alert( error ) );
  }
  
  render() {
    return (
      <Fabric className="ms-Fabric" style={{ paddingBottom: 20, background: "url('/assets/images/people.jpg') no-repeat", height: '100vh', backgroundSize: 'cover' }}>
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
          <Dialog
          hidden={false}
          dialogContentProps={{
            type: DialogType.largeHeader,
            title: 'Gosalbez e Hijos',
            subText:
              'Complete los datos indicados a continuación para ingresar'
          }}
          modalProps={{
            isBlocking: true,
            containerClassName: 'ms-dialogMainOverride'
          }}
        >
          <div class="ms-Grid" dir="ltr">
            <div class="ms-Grid-row">
              <div class="ms-Grid-col ms-sm12 ms-lg12">
              <TextField name="identity" label="Usuario" onChange={ this.updateItem }/>
              </div>
            </div>
            <div class="ms-Grid-row">
              <div class="ms-Grid-col ms-sm12 ms-lg12">
              <TextField name="credential" label="Contraseña" type="password" onChange={ this.updateItem }/>
              </div>
            </div>
          </div>
          <DialogFooter>
            <PrimaryButton onClick={ this.login } text="Ingresar" />
          </DialogFooter>
        </Dialog>
          </div>
        </div>
      </Fabric>
    );
  }
}


// WEBPACK FOOTER //
// ./src/screen/Login.jsx